var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaxPower = function SvgMaxPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M7 2.95H5v1.3h2zM8 4.75H4v1.3h4zM19 2.95h-2v1.3h2zM20 4.75h-4v1.3h4zM22 6.55H2v2h20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M20.5 21.05h-17v-12h17zM14 11.754h-2.568L10 15.429h1.46l-1.325 2.918L14 14.05h-1.621z",
    clipRule: "evenodd"
  })));
};
export default SvgMaxPower;